// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.excel-preview {
  border: 1px solid #d7dee6;
  border-radius: 8px;
  padding: 1rem;
  background: #fff;
}

.excel-preview-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 0.75rem;
}

.excel-preview-title-block {
  min-width: 0;
}

.excel-preview-title-block h3 {
  margin: 0 0 0.25rem 0;
}

.excel-preview-file-name {
  color: #5f6b7a;
  font-size: 0.875rem;
  word-break: break-word;
}

.excel-preview-file-size {
  color: #607286;
  font-size: 0.8rem;
}

.excel-preview-sheet-picker {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.excel-preview-loading {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #495869;
  margin: 0.5rem 0;
}

.excel-preview-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #d7dee6;
  border-top-color: #2a78d1;
  border-radius: 50%;
  animation: excel-preview-spin 0.8s linear infinite;
}

.excel-preview-meta {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 0.75rem;
  color: #495869;
  font-size: 0.875rem;
}

.excel-preview-info {
  color: #495869;
  margin: 0.5rem 0;
}

.excel-preview-table-wrapper {
  border: 1px solid #e3e8ef;
  border-radius: 6px;
  overflow: auto;
  max-height: 520px;
}

.excel-preview-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.excel-preview-table th,
.excel-preview-table td {
  border: 1px solid #e3e8ef;
  padding: 0.375rem 0.5rem;
  text-align: left;
  vertical-align: top;
  white-space: pre-wrap;
}

.excel-preview-row-index {
  position: sticky;
  left: 0;
  background: #f5f8fb;
  color: #607286;
  min-width: 3.5rem;
  width: 3.5rem;
  font-weight: 600;
  z-index: 1;
}

.excel-preview-truncated {
  margin-top: 0.75rem;
  color: #607286;
  font-size: 0.875rem;
}

@media (max-width: 991px) {
  .excel-preview {
    padding: 0.75rem;
  }
}
@keyframes excel-preview-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImV4Y2VsLXByZXZpZXcuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDSSx5QkFBQTtFQUNBLGtCQUFBO0VBQ0EsYUFBQTtFQUNBLGdCQUFBO0FBQ0o7O0FBRUE7RUFDSSxhQUFBO0VBQ0EsOEJBQUE7RUFDQSx1QkFBQTtFQUNBLFNBQUE7RUFDQSxlQUFBO0VBQ0Esc0JBQUE7QUFDSjs7QUFFQTtFQUNJLFlBQUE7QUFDSjs7QUFFQTtFQUNJLHFCQUFBO0FBQ0o7O0FBRUE7RUFDSSxjQUFBO0VBQ0EsbUJBQUE7RUFDQSxzQkFBQTtBQUNKOztBQUVBO0VBQ0ksY0FBQTtFQUNBLGlCQUFBO0FBQ0o7O0FBRUE7RUFDSSxhQUFBO0VBQ0EsbUJBQUE7RUFDQSxXQUFBO0FBQ0o7O0FBRUE7RUFDSSxvQkFBQTtFQUNBLG1CQUFBO0VBQ0EsV0FBQTtFQUNBLGNBQUE7RUFDQSxnQkFBQTtBQUNKOztBQUVBO0VBQ0ksV0FBQTtFQUNBLFlBQUE7RUFDQSx5QkFBQTtFQUNBLHlCQUFBO0VBQ0Esa0JBQUE7RUFDQSxrREFBQTtBQUNKOztBQUVBO0VBQ0ksYUFBQTtFQUNBLFNBQUE7RUFDQSxlQUFBO0VBQ0Esc0JBQUE7RUFDQSxjQUFBO0VBQ0EsbUJBQUE7QUFDSjs7QUFFQTtFQUNJLGNBQUE7RUFDQSxnQkFBQTtBQUNKOztBQUVBO0VBQ0kseUJBQUE7RUFDQSxrQkFBQTtFQUNBLGNBQUE7RUFDQSxpQkFBQTtBQUNKOztBQUVBO0VBQ0ksV0FBQTtFQUNBLHlCQUFBO0VBQ0EsbUJBQUE7QUFDSjs7QUFFQTs7RUFFSSx5QkFBQTtFQUNBLHdCQUFBO0VBQ0EsZ0JBQUE7RUFDQSxtQkFBQTtFQUNBLHFCQUFBO0FBQ0o7O0FBRUE7RUFDSSxnQkFBQTtFQUNBLE9BQUE7RUFDQSxtQkFBQTtFQUNBLGNBQUE7RUFDQSxpQkFBQTtFQUNBLGFBQUE7RUFDQSxnQkFBQTtFQUNBLFVBQUE7QUFDSjs7QUFFQTtFQUNJLG1CQUFBO0VBQ0EsY0FBQTtFQUNBLG1CQUFBO0FBQ0o7O0FBRUE7RUFDSTtJQUNJLGdCQUFBO0VBQ047QUFDRjtBQUVBO0VBQ0k7SUFDSSx1QkFBQTtFQUFOO0VBRUU7SUFDSSx5QkFBQTtFQUFOO0FBQ0YiLCJmaWxlIjoiZXhjZWwtcHJldmlldy5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5leGNlbC1wcmV2aWV3IHtcbiAgICBib3JkZXI6IDFweCBzb2xpZCAjZDdkZWU2O1xuICAgIGJvcmRlci1yYWRpdXM6IDhweDtcbiAgICBwYWRkaW5nOiAxcmVtO1xuICAgIGJhY2tncm91bmQ6ICNmZmY7XG59XG5cbi5leGNlbC1wcmV2aWV3LWhlYWRlciB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gICAgYWxpZ24taXRlbXM6IGZsZXgtc3RhcnQ7XG4gICAgZ2FwOiAxcmVtO1xuICAgIGZsZXgtd3JhcDogd3JhcDtcbiAgICBtYXJnaW4tYm90dG9tOiAwLjc1cmVtO1xufVxuXG4uZXhjZWwtcHJldmlldy10aXRsZS1ibG9jayB7XG4gICAgbWluLXdpZHRoOiAwO1xufVxuXG4uZXhjZWwtcHJldmlldy10aXRsZS1ibG9jayBoMyB7XG4gICAgbWFyZ2luOiAwIDAgMC4yNXJlbSAwO1xufVxuXG4uZXhjZWwtcHJldmlldy1maWxlLW5hbWUge1xuICAgIGNvbG9yOiAjNWY2YjdhO1xuICAgIGZvbnQtc2l6ZTogMC44NzVyZW07XG4gICAgd29yZC1icmVhazogYnJlYWstd29yZDtcbn1cblxuLmV4Y2VsLXByZXZpZXctZmlsZS1zaXplIHtcbiAgICBjb2xvcjogIzYwNzI4NjtcbiAgICBmb250LXNpemU6IDAuOHJlbTtcbn1cblxuLmV4Y2VsLXByZXZpZXctc2hlZXQtcGlja2VyIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgZ2FwOiAwLjVyZW07XG59XG5cbi5leGNlbC1wcmV2aWV3LWxvYWRpbmcge1xuICAgIGRpc3BsYXk6IGlubGluZS1mbGV4O1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgZ2FwOiAwLjVyZW07XG4gICAgY29sb3I6ICM0OTU4Njk7XG4gICAgbWFyZ2luOiAwLjVyZW0gMDtcbn1cblxuLmV4Y2VsLXByZXZpZXctc3Bpbm5lciB7XG4gICAgd2lkdGg6IDE2cHg7XG4gICAgaGVpZ2h0OiAxNnB4O1xuICAgIGJvcmRlcjogMnB4IHNvbGlkICNkN2RlZTY7XG4gICAgYm9yZGVyLXRvcC1jb2xvcjogIzJhNzhkMTtcbiAgICBib3JkZXItcmFkaXVzOiA1MCU7XG4gICAgYW5pbWF0aW9uOiBleGNlbC1wcmV2aWV3LXNwaW4gMC44cyBsaW5lYXIgaW5maW5pdGU7XG59XG5cbi5leGNlbC1wcmV2aWV3LW1ldGEge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZ2FwOiAxcmVtO1xuICAgIGZsZXgtd3JhcDogd3JhcDtcbiAgICBtYXJnaW4tYm90dG9tOiAwLjc1cmVtO1xuICAgIGNvbG9yOiAjNDk1ODY5O1xuICAgIGZvbnQtc2l6ZTogMC44NzVyZW07XG59XG5cbi5leGNlbC1wcmV2aWV3LWluZm8ge1xuICAgIGNvbG9yOiAjNDk1ODY5O1xuICAgIG1hcmdpbjogMC41cmVtIDA7XG59XG5cbi5leGNlbC1wcmV2aWV3LXRhYmxlLXdyYXBwZXIge1xuICAgIGJvcmRlcjogMXB4IHNvbGlkICNlM2U4ZWY7XG4gICAgYm9yZGVyLXJhZGl1czogNnB4O1xuICAgIG92ZXJmbG93OiBhdXRvO1xuICAgIG1heC1oZWlnaHQ6IDUyMHB4O1xufVxuXG4uZXhjZWwtcHJldmlldy10YWJsZSB7XG4gICAgd2lkdGg6IDEwMCU7XG4gICAgYm9yZGVyLWNvbGxhcHNlOiBjb2xsYXBzZTtcbiAgICBmb250LXNpemU6IDAuODc1cmVtO1xufVxuXG4uZXhjZWwtcHJldmlldy10YWJsZSB0aCxcbi5leGNlbC1wcmV2aWV3LXRhYmxlIHRkIHtcbiAgICBib3JkZXI6IDFweCBzb2xpZCAjZTNlOGVmO1xuICAgIHBhZGRpbmc6IDAuMzc1cmVtIDAuNXJlbTtcbiAgICB0ZXh0LWFsaWduOiBsZWZ0O1xuICAgIHZlcnRpY2FsLWFsaWduOiB0b3A7XG4gICAgd2hpdGUtc3BhY2U6IHByZS13cmFwO1xufVxuXG4uZXhjZWwtcHJldmlldy1yb3ctaW5kZXgge1xuICAgIHBvc2l0aW9uOiBzdGlja3k7XG4gICAgbGVmdDogMDtcbiAgICBiYWNrZ3JvdW5kOiAjZjVmOGZiO1xuICAgIGNvbG9yOiAjNjA3Mjg2O1xuICAgIG1pbi13aWR0aDogMy41cmVtO1xuICAgIHdpZHRoOiAzLjVyZW07XG4gICAgZm9udC13ZWlnaHQ6IDYwMDtcbiAgICB6LWluZGV4OiAxO1xufVxuXG4uZXhjZWwtcHJldmlldy10cnVuY2F0ZWQge1xuICAgIG1hcmdpbi10b3A6IDAuNzVyZW07XG4gICAgY29sb3I6ICM2MDcyODY7XG4gICAgZm9udC1zaXplOiAwLjg3NXJlbTtcbn1cblxuQG1lZGlhIChtYXgtd2lkdGg6IDk5MXB4KSB7XG4gICAgLmV4Y2VsLXByZXZpZXcge1xuICAgICAgICBwYWRkaW5nOiAwLjc1cmVtO1xuICAgIH1cbn1cblxuQGtleWZyYW1lcyBleGNlbC1wcmV2aWV3LXNwaW4ge1xuICAgIGZyb20ge1xuICAgICAgICB0cmFuc2Zvcm06IHJvdGF0ZSgwZGVnKTtcbiAgICB9XG4gICAgdG8ge1xuICAgICAgICB0cmFuc2Zvcm06IHJvdGF0ZSgzNjBkZWcpO1xuICAgIH1cbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/pages/invoicing/invoice/excel-preview/excel-preview.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,sBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACI,cAAA;EACA,mBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,cAAA;EACA,iBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;AACJ;;AAEA;EACI,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kDAAA;AACJ;;AAEA;EACI,aAAA;EACA,SAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;AACJ;;AAEA;EACI,cAAA;EACA,gBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AACJ;;AAEA;EACI,WAAA;EACA,yBAAA;EACA,mBAAA;AACJ;;AAEA;;EAEI,yBAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,OAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;AACJ;;AAEA;EACI,mBAAA;EACA,cAAA;EACA,mBAAA;AACJ;;AAEA;EACI;IACI,gBAAA;EACN;AACF;AAEA;EACI;IACI,uBAAA;EAAN;EAEE;IACI,yBAAA;EAAN;AACF;AACA,o6IAAo6I","sourcesContent":[".excel-preview {\n    border: 1px solid #d7dee6;\n    border-radius: 8px;\n    padding: 1rem;\n    background: #fff;\n}\n\n.excel-preview-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 1rem;\n    flex-wrap: wrap;\n    margin-bottom: 0.75rem;\n}\n\n.excel-preview-title-block {\n    min-width: 0;\n}\n\n.excel-preview-title-block h3 {\n    margin: 0 0 0.25rem 0;\n}\n\n.excel-preview-file-name {\n    color: #5f6b7a;\n    font-size: 0.875rem;\n    word-break: break-word;\n}\n\n.excel-preview-file-size {\n    color: #607286;\n    font-size: 0.8rem;\n}\n\n.excel-preview-sheet-picker {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.excel-preview-loading {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    color: #495869;\n    margin: 0.5rem 0;\n}\n\n.excel-preview-spinner {\n    width: 16px;\n    height: 16px;\n    border: 2px solid #d7dee6;\n    border-top-color: #2a78d1;\n    border-radius: 50%;\n    animation: excel-preview-spin 0.8s linear infinite;\n}\n\n.excel-preview-meta {\n    display: flex;\n    gap: 1rem;\n    flex-wrap: wrap;\n    margin-bottom: 0.75rem;\n    color: #495869;\n    font-size: 0.875rem;\n}\n\n.excel-preview-info {\n    color: #495869;\n    margin: 0.5rem 0;\n}\n\n.excel-preview-table-wrapper {\n    border: 1px solid #e3e8ef;\n    border-radius: 6px;\n    overflow: auto;\n    max-height: 520px;\n}\n\n.excel-preview-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.875rem;\n}\n\n.excel-preview-table th,\n.excel-preview-table td {\n    border: 1px solid #e3e8ef;\n    padding: 0.375rem 0.5rem;\n    text-align: left;\n    vertical-align: top;\n    white-space: pre-wrap;\n}\n\n.excel-preview-row-index {\n    position: sticky;\n    left: 0;\n    background: #f5f8fb;\n    color: #607286;\n    min-width: 3.5rem;\n    width: 3.5rem;\n    font-weight: 600;\n    z-index: 1;\n}\n\n.excel-preview-truncated {\n    margin-top: 0.75rem;\n    color: #607286;\n    font-size: 0.875rem;\n}\n\n@media (max-width: 991px) {\n    .excel-preview {\n        padding: 0.75rem;\n    }\n}\n\n@keyframes excel-preview-spin {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
